export default __webpack_public_path__ + "static/media/suitcase-icon.dfa2be71.svg";